import React from 'react';
import styled from '@emotion/styled';
import { PreviewProps } from '../../LandingPagePreview';
import Breathing from '~/App/Components/Shared/Breathing';
import Logo from '../Shared/Logo';
import VideoPlayerPreview from '../Shared/VideoPlayerPreview';
import SocialSharing from '../Shared/SocialSharing';
import MainColumnPreview from '../Shared/MainColumnPreview';
import UserProfile from '../Shared/UserProfile';
import MessageContent from '../Shared/MessageContent';
import { BonjoroBadgeDesktop } from '~/App/Components/BonjoroBadgeDesktop';
import { SentWithBonjoroBadgeStyle } from '@vimily/bonjoro-ui-components-v2/SentWithBonjoroBadge';
import { SentWithBonjoroBadgeSize } from '@vimily/bonjoro-ui-components-v2/SentWithBonjoroBadge';
import LayoutPreview from '../Components/LayoutPreview';

const PostcardContent = styled.div`
  position: relative;
  width: 495px;
  height: 260px;
  display: flex;
  box-shadow: 0 11px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07);
`;

const VidePlayerPreviewWrapper = styled.div`
  flex: 1;
  width: 100%;
`;

const ProfileAndMessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  right: 50%;
  background: #ffffff;
  border-radius: 0 10px 10px 0;
  height: 100%;
  overflow: hidden;
`;

const MessageWrapper = styled.div`
  flex: 1;
  margin: 0 13px;
  overflow-y: auto;
`;

const Postcard = (props: PreviewProps) => {
  const {
    backgroundUrl,
    highlight,
    logoUrl,
    playerImage,
    ctaText,
    secondaryColor,
    ctaUrl,
    showCta,
    color,
    userShortName,
    userName,
    message,
    userImage,
    showSocialSharing,
    showBonjoroBadge,
    hidePreviewTag,
  } = props;

  return (
    <MainColumnPreview centered backgroundUrl={backgroundUrl as string}>
      <div>
        <Breathing
          active={highlight === 'logo'}
          componentClass={Logo}
          logoUrl={logoUrl}
        />
        <PostcardContent>
          <VidePlayerPreviewWrapper>
            <VideoPlayerPreview playerImage={playerImage || ''} />
          </VidePlayerPreviewWrapper>
          <ProfileAndMessageWrapper>
            <UserProfile
              shadowed={false}
              showSocialShare={false}
              userImage={userImage}
              userName={userName}
            />
            <MessageWrapper>
              <MessageContent
                mode='compact'
                userShortName={userShortName}
                message={message}
                highlight={highlight}
                ctaText={ctaText}
                secondaryColor={secondaryColor}
                ctaUrl={ctaUrl}
                showCta={showCta}
                color={color}
              />
            </MessageWrapper>
          </ProfileAndMessageWrapper>
          {showSocialSharing && <SocialSharing />}
        </PostcardContent>
      </div>
      {showBonjoroBadge && (
        <BonjoroBadgeDesktop
          className='absolute bottom-0 left-1/2 -translate-x-1/2 z-[105]'
          size={SentWithBonjoroBadgeSize.Large}
          style={SentWithBonjoroBadgeStyle.Full}
          cssStyle={{
            zoom: '0.6',
          }}
        />
      )}
      {!hidePreviewTag && <LayoutPreview />}
    </MainColumnPreview>
  );
};

export default Postcard;
